import { acceptHMRUpdate, defineStore } from "pinia";
import { ref, computed } from "vue";
import { useSupabase } from "../composables/supabase";
export type UserData = Record<string, any>;

export const useUserSession = defineStore("userSession", () => {
  const user = ref<Partial<UserData>>();
  const supabase = useSupabase();

  const isLoggedIn = computed(() => user.value !== undefined);

  const getSession = async () => {
    // Verify if the user has signed up
    const { data, error } = await supabase.auth.getSession();

    if (data.session) {
      setUser(data.session.user);
      return true;
    }
    if (error) {
      console.error("Error getting session:", error);
      return false;
    }
    return false;
  };

  function setUser(newUser: Partial<UserData>) {
    user.value = newUser;
  }

  async function logoutUser() {
    user.value = undefined;
  }

  return {
    user,
    isLoggedIn,
    logoutUser,
    getSession,
    setUser,
  } as const;
});

/**
 * Pinia supports Hot Module replacement so you can edit your stores and
 * interact with them directly in your app without reloading the page.
 *
 * @see https://pinia.esm.dev/cookbook/hot-module-replacement.html
 * @see https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserSession, import.meta.hot));
}
